import type { FC } from 'react'
import React from 'react'

import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import LogoTiles from '@segment/templates/LogoTiles'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const data = {
  heading: `Collect web and mobile analytics`,
  description: `Collect data once with Segment and send it any tool you use.<br>No more tedious integrations.`,
}

const BaseGettingStarted: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h3" variant="h2">
            {data.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge" dangerouslySetInnerHTML={{ __html: data.description }} />
        </CopyTextBase>
        <Content>
          <Button size="large" color="primary" variant="filled" tag="a" href={getAbsoluteUrl(`/demo/`, pageConfig)}>
            Request a demo
          </Button>
        </Content>
      </Copy>
      <LogoTiles />
    </Wrapper>
  )
}

export default BaseGettingStarted

export const Wrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export const Copy = styled.div`
  display: grid;
  justify-content: center;
  row-gap: 40px;
  padding: 40px 20px 0;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 80px 80px 30px;
  }
`

export const Content = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
`
